import Vue from 'vue';

import Cleave from '@/directives/Cleave';

Vue.use(Cleave);
